/* eslint-disable newline-before-return */
import { FC } from 'react';
import {
  Message,
  Dimmer,
  Loader,
} from 'semantic-ui-react';

export type SelectOptionType = {
  key: string;
  value: string;
  text: string;
};

export type APIErrorType = { errors: Array<{ message: string }> };

export type AppErrorInterface = {
  isError: boolean;
  message: string;
};

export const AppError: FC<AppErrorInterface> = (error) => {
  if (!error.isError) return <></>;

  return (
    <Message negative>
      <Message.Header>Someting Error occured.</Message.Header>
      {error.message}
    </Message>
  );
};

interface LoadingInterface {
  active: boolean;
}

export const Loading: FC<LoadingInterface> = (props) => {
  return (
    props.active && (
      <Dimmer active page>
        <Loader>Loading</Loader>
      </Dimmer>
    )
  );
};
